import React from "react";
import { motion } from "framer-motion/dist/framer-motion";
import { useTranslation } from "react-i18next/";
import { StyledBreadcrumb } from "@aureskonnect/react-ui";
import PageTitle from "@components/Common/PageTitle";
import { useSnapshot } from "valtio";
import { store as userStore } from "@components/VerticalLayout/store";
import { CARD_MENU_LIST } from "../Applications/Home/cardMenuList";
import CardMenu from "../Applications/Home/CardMenu";
import { getPathAuthorization } from "@components/VerticalLayout";

import "../Applications/Home/Cartestyle.css";

export function Dashboard() {
    const { t } = useTranslation();
 const { oneShop } = useSnapshot(
     userStore
 );
    return (
        <React.Fragment>
            <PageTitle title={"Applications"} />
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 1 }}
                className="page-content__clz"
            >
                <StyledBreadcrumb
                    items={[
                        {
                            item: "Settings".toUpperCase(),
                            link: `${process.env.REACT_APP_PORTAIL_URL}`,
                        },
                        {
                            item:
                                localStorage
                                    .getItem("selectedAccount")
                                    ?.toUpperCase() || "",
                            link: oneShop
                                ? "/setting/customer-account"
                                : "/compte",
                        },
                        {
                            item: t("Dashboard").toUpperCase(),
                            link: "#",
                        },
                    ]}
                />
                <h1
                    style={{
                        color: "#101111",
                        marginLeft: "25px",
                        marginTop: "9px",
                    }}
                >
                    {t("Dashboard")}
                </h1>
                <div className="row p-4">
                    {CARD_MENU_LIST.map((cardMenu, index) => {
                        if (
                            getPathAuthorization(cardMenu.path).Visible === true
                        ) {
                            return (
                                <CardMenu
                                    key={index}
                                    title={cardMenu.title}
                                    number={cardMenu.number}
                                    Icon={cardMenu.Icon}
                                    description={cardMenu.description}
                                    path={cardMenu.path}
                                    numberKiosk=""
                                />
                            );
                        } else {
                            return null;
                        }
                    })}
                </div>
            </motion.div>
        </React.Fragment>
    );
}
